import { Station } from './../../models/station';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { StationService } from 'src/app/services/station.service';
import { ReservationService } from 'src/app/services/reservation.service';
import { ArService } from 'src/app/services/ar.service';

@Component({
  selector: 'app-agencies',
  templateUrl: './agencies.component.html',
  styleUrls: ['./agencies.component.scss']
})
export class AgenciesComponent implements OnInit {

  allAgencyServices;
  stationsList;
  activePage
  searchText;


  constructor(private router: Router,
    private spinner: NgxSpinnerService,
    private reservationService: ReservationService,
    private stationService: StationService,
    private arService: ArService) {
    this.getData();
  }

  getData() {
    this.searchText = ''
    this.getAgencyServices();
  }

  ngOnInit() {
    this.getAgencyServices();
   }

  addAgencyService() {
    this.router.navigateByUrl("home/add-agency-service");
  }

  editAgencyService(agencyService) {
    this.router.navigate(["home/edit-agency-service",agencyService.AGENCY_ID])
  }

  calculateActiveAgencies(agencies) {
    let activeCount = 0
    agencies.forEach(agency => {
      if (agency.ACTIVE) {
        activeCount++
      }
    });
    return activeCount
  }

  calculateInActiveAgencies(agencies) {
    let inactiveCount = 0
    agencies.forEach(agency => {
      if (!agency.ACTIVE) {
        inactiveCount++
      }
    });
    return inactiveCount
  }
  
  getAgencyServices() {
    this.spinner.show();
    this.arService.getAllAgencies().subscribe(res => {
      this.allAgencyServices = res['result'].sort((a, b) => a.STATION.localeCompare(b.STATION))
    //  console.log(this.allAgencyServices)
      this.spinner.hide();
    });
  }

  getAgencyServicesByStationIds() {
    // this.employeeService.getEmployeesByStationId(this.stationsList).subscribe(data => {
    //   this.spinner.hide();
    //   if (data['result'] != null) {
    //     this.allEmployees = data['result'] as [];
    //     this.allEmployees = this.allEmployees.reverse();
    //   }
    // });
  }

  

  getAllStations() {
    this.stationService.getStations().subscribe(stations => {
      this.stationsList = stations['result'];
     // console.log(this.stationsList)
    })
  }

}
